import { useTheme } from "@emotion/react";
import {
  CheckBoxDesmarcado,
  CheckBoxIndeterminado,
  CheckBoxMarcado,
  Linha,
  LinhaCheckboxRef,
} from "./styles";
import useTamanhoTela from "../../utils/useTamanhoTela";

const definirTamanho = (tamanho, largura) => {
  switch (tamanho) {
    case "SM":
      return 0.7;
    case "MD":
      return 1;
    case "LG":
      return 1.3;
    default:
      return largura < 768 ? 1.3 : 1;
  }
};

export const CheckBox = ({
  cor,
  corTexto,
  desabilitado,
  indeterminate = false,
  onClick,
  ref,
  style,
  styleCheckbox,
  tabIndex = 0,
  tamanho,
  tamanhoTexto,
  texto,
  titulo,
  valor,
  value,
}) => {
  const theme = useTheme();
  const { largura } = useTamanhoTela();
  return (
    <Linha
      onClick={onClick}
      style={{
        ...style,
      }}
      desabilitado={desabilitado}
      ref={ref}
    >
      {indeterminate ? (
        <CheckBoxIndeterminado
          tabIndex={tabIndex}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick();
            }
          }}
          cor={cor}
          style={{
            ...styleCheckbox,
            minWidth: 24,
            transform: `scale(${definirTamanho(tamanho, largura)})`,
          }}
          desabilitado={desabilitado}
        />
      ) : valor || value ? (
        <CheckBoxMarcado
          tabIndex={tabIndex}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick();
            }
          }}
          cor={cor}
          style={{
            ...styleCheckbox,
            minWidth: 24,
            transform: `scale(${definirTamanho(tamanho, largura)})`,
          }}
          desabilitado={desabilitado}
        />
      ) : (
        <CheckBoxDesmarcado
          tabIndex={tabIndex}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick();
            }
          }}
          cor={cor}
          style={{
            ...styleCheckbox,
            minWidth: 24,
            transform: `scale(${definirTamanho(tamanho, largura)})`,
          }}
          desabilitado={desabilitado}
        />
      )}
      {(texto || titulo) && (
        <p
          style={{
            margin: 0,
            color: corTexto ? corTexto : theme.cores.textoSimples,
            opacity: desabilitado ? 0.5 : 1,
            fontSize: tamanhoTexto ? tamanhoTexto : 15,
            display: "block",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {texto || titulo}
        </p>
      )}
    </Linha>
  );
};

export const CheckBoxRef = ({ refs, style, className }) => {
  const theme = useTheme();
  const { largura } = useTamanhoTela();
  return (
    <LinhaCheckboxRef
      className={className}
      style={{
        ...style,
      }}
      ref={refs}
    >
      <CheckBoxMarcado />
      <CheckBoxDesmarcado />
    </LinhaCheckboxRef>
  );
};
